import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './languageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const timeoutRef = useRef(null);

  const changeLanguage = (event) => {
    const next = event.target.value;
    if (next === i18n.language) return;

    // Petit fondu du contenu pour rendre le changement fluide
    document.documentElement.classList.add('lang-switching');
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      i18n.changeLanguage(next);
      setTimeout(() => {
        document.documentElement.classList.remove('lang-switching');
      }, 180);
    }, 160);
  };

  return (
    <div className="language-selector">
      <select
        value={i18n.language || 'en'}
        onChange={changeLanguage}
        className="language-dropdown"
        aria-label="Select language"
      >
        <option value="en">EN</option>
        <option value="fr">FR</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
